module.exports = __webpack_public_path__ + "img/077-france.babc92cc.svg";